import { render, staticRenderFns } from "./RecipeIngredient.vue?vue&type=template&id=521f0a6e&scoped=true"
import script from "./RecipeIngredient.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeIngredient.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecipeIngredient.vue?vue&type=style&index=0&id=521f0a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f0a6e",
  null
  
)

export default component.exports